'use strict';

class GatewaysTotalPageController {
  constructor($scope,
              $q,
              $filter,
              DashboardDataProvider) {
    const $t = $filter('translate');
    const currentDateFormat = $t('dash.panel.currentDateFormat');
    var initial = true;

    angular.extend($scope, {
      getData: getData
    });

    function getData(startDate, endDate) {
      return DashboardDataProvider.getTotalGateways(startDate, endDate)
        .then((reportInfo) => {

          if (!reportInfo || !reportInfo.dictionary || reportInfo.dictionary.length <= 0 || !reportInfo.executions || reportInfo.executions.length <= 0) {
            return [];
          }

          let executions = reportInfo.executions
            .slice()
            .sort((a, b) => a.executionDateMs - b.executionDateMs); // latest last

          let connectedGateways = executions
            .map(execution => ({
              x: execution.executionDateMs,
              y: execution.data?.find(d => d.id === 1)?.value || 0
            }));

          let disconnectedGateways = executions
            .map(execution => ({
              x: execution.executionDateMs,
              y: execution.data?.find(d => d.id === 2)?.value || 0
            }));

          if (initial) {
            getLastMeasurement(executions[executions.length - 1]);
            initial = false;
          }

          return [
            {
              data: disconnectedGateways,
              label: $t('dash.panel.reports.totalGateways.disconnected')
            },
            {
              data: connectedGateways,
              label: $t('dash.panel.reports.totalGateways.connected')
            }
          ];
        });
    }

    // Get last measurement from initial call
    function getLastMeasurement(executions) {
      if (!executions) {
        return;
      }

      let info = [];
      const dictionaryHelper = [
        {
          id: 1,
          name: $t('dash.panel.reports.totalGateways.connected'),
          icon: 'router'
        },
        {
          id: 2,
          name: $t('dash.panel.reports.totalGateways.disconnected'),
          icon: 'times'
        }
      ];

      info.push({
        icon: 'clock',
        name: $t('dash.panel.reports.lastMeasured'),
        value: $filter('date')(executions.executionDateMs, currentDateFormat)
      });

      for (let [key, value] of Object.entries(executions.data || {})) {
        let helper = dictionaryHelper.find(el => el.id === value.id);
        if (helper) {
          info.push({
            icon: helper.icon || 'chart-line',
            name: helper.name + ' -',
            value: value.value
          });
        }
      }
      $scope.lastMeasurement = info;
    }
  }
}

export default angular
  .module('main.dashboard.gatewaysTotalPage.controller', [])
  .controller('GatewaysTotalPageController', GatewaysTotalPageController)
  .name;
